import { Breadcrumbs, Button, Container, Grid, Link, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import LinearProgressWithLabel from "../LinearProgressWithLabel";
import { LoadingPage } from "../LoadingPage";
import { withAuthorization } from "../Session";
import { CourseItem } from "./CourseItem";
import { Finish } from "./Finish";
import * as ROUTES from "../../constants/routes";
import { useTranslation } from "react-i18next";
import { Home } from "@material-ui/icons";

export const CoursePage = (props) => {
  //console.log(props);
  let { id } = useParams();
  const { t } = useTranslation();
  const { firebase } = props;
  const history = useHistory();
  const [currentItemPos, setcurrentItemPos] = useState(0);
  const [itemsData, setitemsData] = useState({});
  const [data, setData] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [finished, setfinished] = useState(false);

  useEffect(() => {
    /**
     * equivale al component didmount
     * prepara el estado con los datos del curso obtenidos desde firebase
     */
    getCourseData();
    window.onpopstate = (e) => {
      e.preventDefault();
      history.push(ROUTES.MODULE.replace(":id", id));
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const getCourseData = async () => {
    try {
      const courseSnap = await firebase.course(id).once("value");
      const courseData = courseSnap.val();

      if (!courseData || !courseData.items) {
        console.warn("El curso no contiene items válidos");
        setLoaded(true);
        return;
      }

      setData({ ...courseData, id });

      const itemsPromises = courseData.items.map((itemId) =>
        firebase
          .coursesItem(itemId)
          .once("value")
          .then((snap) => snap.val())
      );

      const items = await Promise.all(itemsPromises);

      const itemsMap = {};
      items.forEach((item, index) => {
        itemsMap[index] = item;
      });

      setitemsData(itemsMap);
      setLoaded(true);
    } catch (error) {
      console.error("Error cargando datos del curso:", error);
      setLoaded(true);
    }
  };

  /** efecto para reiniciar el componente cuando se cambie el identificador */
  useEffect(() => {
    setLoaded(false);
    setcurrentItemPos(0);
    setfinished(false);
    getCourseData();
  }, [id]);

  /** Previous Fase Hanlder */
  const previousFase = () => {
    window.scrollTo({ top: 0, behavior: "auto" });
    if (currentItemPos != 0) {
      setcurrentItemPos(currentItemPos - 1);
    } else {
      history.push(ROUTES.MODULE.replace(":id", id));
    }
  };

  /** Next Fase Hanlder */

  /**
   * Si se ha llegado a la ultima fase, se podran el curso como terminado en el reporte del usuario,
   * esto permitira saber si el usuario ha completado el curso antes de poder hacer la evaluación
   */
  const nextFase = () => {
    //console.log(firebase.currentUser().uid);
    if (currentItemPos >= data.items.length - 1) {
      //setfinished(true);
      /*  Se actualiza el estado del curso para el usuario
       *   se pone finalizado para futuras implementaciones sobre estadisticas del usuario
       *
       * */
      firebase
        .userReport(firebase.currentUser().uid)
        .child(`courses/${id}`)
        .update({ finished: true })
        .then(() => {
          firebase
            .userReport(firebase.currentUser().uid)
            .child(`tests/${data.testRef}/metadata`)
            .update({ studed: true })
            .then(() => {
              window.scrollTo({ top: 0, behavior: "auto" });
              history.push(ROUTES.MODULE.replace(":id", id));
            });
        });
      /* Se ACTUALIZA el reporte del test para saber que ha sido estudiado */
    } else {
      window.scrollTo({ top: 0, behavior: "auto" });
      setcurrentItemPos(currentItemPos + 1);
    }
  };

  /**
   * Se renderizara una vez se hayan cargado todos los datos del curso
   */
  if (loaded) {
    // si no se ha terminado el curso se renderizan los contenidos

    return (
      <Container>
        <Grid container justify="center" style={{ marginTop: 24 }}>
          <Grid item xs={12} lg={9}>
            <Breadcrumbs style={{ marginBottom: 24 }}>
              <Link
                color="inherit"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  history.push(ROUTES.HOME);
                  window.scrollTo({ y: 0, behavior: "smooth" });
                }}
              >
                <div style={{ display: "flex" }}>
                  <Home style={{ paddingBottom: 8, paddingRight: 4 }} />
                  <Typography style={{ paddingTop: 4, textDecoration: "underline" }}>{t("curso_Online")}</Typography>
                </div>
              </Link>

              <Link
                color="inherit"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => {
                  history.push(ROUTES.MODULE.replace(":id", id));
                  window.scrollTo({ y: 0, behavior: "smooth" });
                }}
              >
                {t(id?.replace("FCS", ""))}
              </Link>
              <Typography color="textPrimary">{t("contenidos")}</Typography>
            </Breadcrumbs>
            <LinearProgressWithLabel value={((currentItemPos + 1) / data.items.length) * 100} color="secondary" />
          </Grid>
        </Grid>
        <CourseItem data={itemsData[currentItemPos]} />
        <Grid container justify="flex-end" alignItems="center" direction="row" item style={{ marginTop: 24, paddingBottom: 36 }}>
          <Grid item xs={6} container justify="center">
            <Button variant="outlined" style={{ textTransform: "none" }} onClick={() => previousFase()} color="secondary">
              {currentItemPos == 0 ? t("volver_al_modulo") : t("previous")}
            </Button>
          </Grid>
          <Grid item xs={6} container justify="center">
            <Button variant="contained" style={{ textTransform: "none", color: "whitesmoke" }} onClick={() => nextFase()} color="primary">
              {currentItemPos == data.items.length - 1 ? t("finish") : t("next")}
            </Button>
          </Grid>
        </Grid>
      </Container>
    );
  } else {
    return <LoadingPage />;
  }
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(CoursePage);
